import { ACTIVATED, DISABLED, INCOMPATIBLE, RUNNING_ACTIVATED, RUNNING_DISABLED, RUNNING_GETINFO } from "@/constants/cerberus";

const hasCompatibleLines = (lines = []) =>
  Array.isArray(lines) && lines.some(({ status } = {}) => status !== INCOMPATIBLE);

const hasCompatibleLineByPhoneNumber = (lines = [], phoneNumber) =>
  Array.isArray(lines) &&
  lines.some(
    ({ status, telcoPhoneNumber } = {}) =>
      telcoPhoneNumber === phoneNumber && status !== INCOMPATIBLE
  );

const hasStatusOnlyCompatibility = (item = {}) => {
  const hasAnyLines =
    (Array.isArray(item?.mobileLines) && item.mobileLines.length > 0) ||
    (Array.isArray(item?.bafLines) && item.bafLines.length > 0);

  return item?.showSwitch !== false && Boolean(item?.status) && !hasAnyLines;
};

export const hasAnyCompatibleMobileLine = (data) => {
  if (!data) return false;

  return Object.values(data).some(service =>
    service?.infoSwitch?.some((item) => {
      return (
        hasCompatibleLines(item?.mobileLines) ||
        hasCompatibleLines(item?.bafLines) ||
        hasStatusOnlyCompatibility(item)
      );
    })
  );
}

export const hasAnyCompatibleServiceByPhoneNumber = (data, phoneNumber) => {
  if (!data || !phoneNumber) return false;

  return Object.values(data).some(service =>
    service?.infoSwitch?.some((item) => {
      return (
        hasCompatibleLineByPhoneNumber(item?.mobileLines, phoneNumber) ||
        hasCompatibleLineByPhoneNumber(item?.bafLines, phoneNumber) ||
        hasStatusOnlyCompatibility(item)
      );
    })
  );
}

export const findSpamBlockCallsCompatibleLines = (info) => {
  const infoSwitch = info?.spamCallsBlocking?.infoSwitch;

  if (!Array.isArray(infoSwitch) || infoSwitch.length === 0) {
    return null;
  }

  const compatibles = infoSwitch.map((item) => findMobileLinesCompatibles(item?.mobileLines))
  return Array.isArray(compatibles) && compatibles.length > 0
};

export const findPhoneCallsErrorLines = (info) => {
  const infoSwitch = info?.phoneCallsIdentifier?.infoSwitch;

  if (!Array.isArray(infoSwitch) || infoSwitch.length === 0) {
    return null;
  }

  return infoSwitch.find((item) => item?.errorLines !== undefined);
};

export const findSpamBlockCallsErrorLines = (info) => {
  const infoSwitch = info?.spamCallsBlocking?.infoSwitch;

  if (!Array.isArray(infoSwitch) || infoSwitch.length === 0) {
    return null;
  }

  return infoSwitch.find((item) => item?.errorLines !== undefined);
};

export const showPillProfile = (info) => {
  const phoneCallsDisabled = info?.phoneCallsIdentifier?.status === DISABLED;
  const spamCallsBlockingDisabled =
    info?.spamCallsBlocking?.status === DISABLED;

  if (phoneCallsDisabled === true && spamCallsBlockingDisabled === true)
    return true;
};

const hasDisabledState = (switches = []) =>
 switches.some(({ status } = {}) => status === DISABLED);

const hasShowState = (switches = [], value) =>
 switches.some(({ status } = {}) => status === ACTIVATED || (status === DISABLED && Boolean(value > 0)));

export const showLinkCallsIdentifierInSummary = (info, value) =>
  hasShowState(info?.phoneCallsIdentifier?.infoSwitch, value);

export const showLinkCallsBlocksInSummary = (info, value) =>
  hasShowState(info?.spamCallsBlocking?.infoSwitch, value);

export const showLinkFraudulentSMSBlockingInSummary = (info, value) =>
  hasShowState(info?.fraudulentSMSBlocking?.infoSwitch, value);

export const disabledCallsIdentifierInSummary = (info) =>
  hasDisabledState(info?.phoneCallsIdentifier?.infoSwitch);

export const disabledCallsBlocksInSummary = (info) =>
  hasDisabledState(info?.spamCallsBlocking?.infoSwitch);

export const disabledFraudulentSMSBlockingInSummary = (info) =>
  hasDisabledState(info?.fraudulentSMSBlocking?.infoSwitch);

export const hasRunningState = (switches = []) =>
  switches.some(
    ({ status } = {}) =>
      [RUNNING_ACTIVATED, RUNNING_DISABLED, RUNNING_GETINFO].includes(status)
  );

export const isCerberusRunning = (info) =>
  hasRunningState(info?.phoneCallsIdentifier?.infoSwitch) ||
  hasRunningState(info?.spamCallsBlocking?.infoSwitch) ||
  hasRunningState(info?.fraudulentSMSBlocking?.infoSwitch);

